
import { Booking } from "@/api/dtos/Booking.schema";
import { BookingDetails } from "@/api/dtos/BookingDetails.schema";
import BookingsTable from "@/components/bookings/BookingsTable.vue";
import { Component, ModelSync, Prop, Vue, Watch } from "vue-property-decorator";
import ContainerFrame from "../ContainerFrame.vue";
import EditFrame from "../EditFrame.vue";
import BookingProgressBar from "./BookingProgressBar.vue";
import moment from "moment";
import RefundBookingDialog from "./RefundBookingDialog.vue";
import api from "@/api";
import {
  formatBookingDateTime,
  hasBookingTimeZone,
} from "@/utils/bookingDateFormatter";

@Component({
  components: {
    BookingsTable,
    ContainerFrame,
    EditFrame,
    BookingProgressBar,
    RefundBookingDialog,
  },
})
export default class BookingDetailsDialog extends Vue {
  @ModelSync("value", "input")
  show!: boolean;

  @Prop()
  bookingDetails!: BookingDetails;

  moment = moment;
  formatBookingDateTime = formatBookingDateTime;
  hasBookingTimeZone = hasBookingTimeZone;

  showRefundDialog = false;
  bookingToRefund: Booking | null = null;

  stationImage: File | null = null;

  @Watch("bookingDetails")
  async onBookingDetailsChange() {
    if (!this.bookingDetails) {
      this.stationImage = null;
    } else {
      this.stationImage =
        (await api.StationsApi.getStationImage(
          this.bookingDetails.stationUuid
        )) ?? null;
    }
  }

  get imageUrl() {
    if (this.stationImage) {
      return URL.createObjectURL(this.stationImage);
    }
    return undefined;
  }

  downloadInvoice(booking: Booking): void {
    api.BookingsApi.downloadBookingInvoice(
      this.bookingDetails.bookingId,
      booking.bookingId
    );
  }

  downloadAllBookings(): void {
    api.BookingsApi.downloadBookingInvoices(this.bookingDetails.bookingId);
  }

  onRefund(refund: { refundAmountEuros: number; message: string }): void {
    this.showRefundDialog = false;
    if (this.bookingToRefund) {
      api.BookingsApi.cancelSubBooking(
        this.bookingDetails.bookingId,
        this.bookingToRefund.bookingId,
        refund
      );
    }
    this.bookingToRefund = null;
  }
}
